export default "__VITE_ASSET__6fcaa277__"